function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgCircleQuestion(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M48 4C23.7 4 4 23.699 4 48s19.7 44 44 44 44-19.699 44-44S72.3 4 48 4zm0 80c-19.882 0-36-16.118-36-36s16.118-36 36-36 36 16.118 36 36-16.118 36-36 36z"
  }), React.createElement("circle", {
    cx: 49.75,
    cy: 73.917,
    r: 4.25
  }), React.createElement("path", {
    d: "M51.984 19.623c-4.408-1.118-8.501-.594-11.833 1.518-5.762 3.653-7.257 10.598-7.409 11.377a3.99 3.99 0 003.142 4.672 4.011 4.011 0 004.707-3.123c.25-1.204 1.432-4.663 3.874-6.189 1.463-.915 3.278-1.079 5.551-.502 2.914.74 4.747 2.28 5.447 4.576.72 2.36.048 5.069-.986 6.226-1.022 1.142-2.024 2.033-2.994 2.895-2.338 2.077-4.754 4.224-5.393 8.394-.371 2.428-.631 10.347-.68 11.909a4 4 0 007.996.248c.106-3.432.36-9.438.592-10.947.183-1.195.693-1.754 2.798-3.624 1.031-.917 2.314-2.057 3.642-3.54 3.037-3.394 4.138-9.107 2.677-13.895-1.529-5.011-5.482-8.56-11.131-9.995z"
  }));
}

SvgCircleQuestion.clsName = 'icon-www__circle-question';
SvgCircleQuestion.remarkName = 'unknown';
export default SvgCircleQuestion;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/CircleQuestion.js
// module id = 2315
// module chunks = 17 18